import React from 'react';
import { FundItem } from '../../../../models/Fund';
import ContentBox from '../../../common/ContentBox';
import { useTranslation } from 'react-i18next';
import { Box, Divider, Typography } from '@mui/material';
import StageDistributionGraph from '../../../common/StageDistributionGraph';
import GeographicDistributionGraph from '../../../common/GeographicDistributionGraph';

export interface IOverviewStageDistributionProps {
    fund: FundItem;
}

const OverviewStageDistribution: React.FC<IOverviewStageDistributionProps> = ({ fund }) => {
    const { t } = useTranslation();
    return <ContentBox proportion={1}>
        <Box display={"flex"} flexDirection={"column"} gap={"20px"}>
            <Typography fontSize={"18px"} lineHeight={"21.94px"} fontWeight={"600"}>{t('LibraryOfFundsOverviewTabStageTitle')}</Typography>
            <StageDistributionGraph data={fund.stageDistribution} />
            <Divider />
            <Typography fontSize={"18px"} lineHeight={"21.94px"} fontWeight={"600"}>{t('LibraryOfFundsOverviewTabGeographicTitle')}</Typography>
            <GeographicDistributionGraph distribution={fund.geographicDistribution} />
        </Box>
    </ContentBox>
}

export default OverviewStageDistribution;